document.addEventListener('DOMContentLoaded', () => {
    const CHECKOUT_BTN_SELECTOR = [
        'cart-drawer .cart__checkout-button',
        '#CartDrawer .cart__checkout-button',
        '.cart-drawer .cart__checkout-button',
        'cart-drawer button[name="checkout"]',
        '#CartDrawer button[name="checkout"]',
        'cart-drawer input[name="checkout"]',
        '#CartDrawer input[name="checkout"]',
        'cart-drawer a[href*="/checkout"]',
        '#CartDrawer a[href*="/checkout"]'
    ].join(',');

    const MOBILE_BREAKPOINT = 989;
    const MOBILE_DOM_SETTLE_DELAY = 450;

    const popup = document.getElementById('conversion-popup');
    const productList = document.getElementById('one-time-product-list');

    let cachedHasSubscriptionForUpsell = null;
    let cachedConversionItems = [];
    let isCheckoutProcessing = false;
    let shippingProtectionPromise = null;

    function isMobileViewport() {
        return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
    }

    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function waitForMobileDrawerSettle() {
        if (isMobileViewport()) {
            await delay(MOBILE_DOM_SETTLE_DELAY);
        }
    }

    async function getFreshCart() {
        const response = await fetch('/cart.js', {
            method: 'GET',
            cache: 'no-store',
            headers: {
                Accept: 'application/json'
            }
        });

        if (!response.ok) {
            const text = await response.text();
            throw new Error(text || 'Failed to fetch cart');
        }

        return response.json();
    }

    function setButtonLoading(button, text) {
        if (!button) return;

        if (!button.dataset.originalText) {
            button.dataset.originalText = button.textContent.trim();
        }

        button.dataset.loading = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = text;

        /**
         * Force browser paint on mobile before async request starts.
         */
        button.offsetHeight;
    }

    function resetButtonLoading(button, fallbackText = 'Claim Offer') {
        if (!button) return;

        button.dataset.loading = 'false';
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = button.dataset.originalText || fallbackText;
    }

    async function waitForShippingProtectionIfRunning() {
        if (!shippingProtectionPromise) return;

        try {
            await shippingProtectionPromise;
        } catch (error) {
            console.error('Shipping protection sync failed:', error);
        }
    }

    const proceedToCheckout = async (checkoutUrl = '/checkout') => {
        if (popup) {
            popup.style.display = 'none';
        }

        await waitForShippingProtectionIfRunning();

        window.location.href = checkoutUrl;
    };

    function getCartStateFromDOM() {
        const cartItems = document.querySelectorAll('.cart-drawer-item');

        let hasSubscription = false;
        let hasOneTime = false;

        cartItems.forEach(item => {
            const productType = item.getAttribute('data-item-type');

            if (productType === 'subscription') {
                hasSubscription = true;
            } else if (productType === 'one-time') {
                hasOneTime = true;
            }
        });

        return {
            hasSubscription,
            hasOneTime,
            itemCount: cartItems.length
        };
    }

    function getCartStateFromCart(cart) {
        let hasSubscription = false;
        let hasOneTime = false;

        if (!cart || !Array.isArray(cart.items)) {
            return { hasSubscription, hasOneTime };
        }

        cart.items.forEach(item => {
            if (item.selling_plan_allocation != null) {
                hasSubscription = true;
            } else {
                hasOneTime = true;
            }
        });

        return { hasSubscription, hasOneTime };
    }

    const collectOneTimeItems = () => {
        const items = document.querySelectorAll('[data-item-type="one-time"]');

        const collectedItems = Array.from(items).map(el => {
            const itemKey = el.getAttribute('data-item-key');
            const productId = el.getAttribute('data-product-id');
            const variantId = el.getAttribute('data-variant-id');
            const sellingPlanId = el.getAttribute('data-subscription-plan-id');

            const imageEl = el.querySelector('.cart-item__image');
            const priceEl = el.querySelector('.cart-item__price-wrapper .regular-price');
            const quantityElement = el.querySelector('.cart-item__quantity-input') || el.querySelector('.cart-item__quantity');
            const quantityInput = quantityElement ? quantityElement.querySelector('.quantity__input') : null;

            const productImg = imageEl ? imageEl.getAttribute('src') : '';
            const price = priceEl ? priceEl.innerText : '';
            const quantity = quantityInput ? quantityInput.value : 1;

            if (!sellingPlanId || sellingPlanId.trim() === '') {
                return null;
            }

            return {
                key: itemKey,
                product_image: productImg,
                variantId: variantId,
                productId: productId,
                name: el.querySelector('.cart-item__name')?.textContent || 'One-Time Product',
                quantity: quantity,
                compare_price: price,
                sellingPlanId: sellingPlanId
            };
        }).filter(Boolean);

        if (collectedItems.length > 0) {
            cachedConversionItems = collectedItems;
        }

        return collectedItems;
    };

    function buildProductList(items) {
        if (!productList) {
            proceedToCheckout();
            return;
        }

        cachedConversionItems = items || [];
        productList.innerHTML = '';

        items.forEach(item => {
            let formattedAmount = 0;
            let compare_price = item.compare_price;
            let regular_price = "";

            if (item.productId == "11721539486014") {
                if (item.quantity == 3) {
                    regular_price = 59;
                } else if (item.quantity == 2) {
                    regular_price = 49;
                } else if (item.quantity == 1) {
                    regular_price = 25;
                }

                if (regular_price === "" || regular_price === undefined) {
                    compare_price = "";
                }

                if (window?.Shopify?.currency?.rate && regular_price) {
                    const rate = Shopify.currency.rate;
                    const currency = Shopify.currency.active;
                    const discountInLocal = regular_price * rate;

                    formattedAmount = new Intl.NumberFormat(undefined, {
                        style: 'currency',
                        currency: currency
                    }).format(discountInLocal);
                }
            } else {
                formattedAmount = compare_price;
                compare_price = "";
            }

            const li = document.createElement('li');
            li.className = 'conversion-item';
            li.setAttribute('data-item-key', item.key || '');

            li.innerHTML = `
                <div class="subscription-product-info">
                    <div class="subscription-product-image">
                        <img src="${item.product_image || ''}">
                    </div>
                    <div class="subscription-product-detail">
                        <span class="product-name">${item.name || 'One-Time Product'}</span>
                        <dl>
                            <span class="popup-price popup-regular-price">${formattedAmount}</span>
                            <span class="popup-price popup-compare-price">${compare_price}</span>
                        </dl>
                        <button
                            type="button"
                            class="convert-single-item-btn button button--small button--primary"
                            data-item-key="${item.key || ''}"
                            data-item-variant="${item.variantId || ''}"
                            data-selling-plan-id="${item.sellingPlanId || ''}"
                            data-quantity="${item.quantity || 1}"
                        >
                            Claim Offer
                        </button>
                    </div>
                </div>
            `;

            productList.appendChild(li);
        });
    }

    function getCachedConversionItem(itemKey, itemVariant, sellingPlanId) {
        return cachedConversionItems.find(item => {
            const sameKey = itemKey && item.key === itemKey;
            const sameVariantPlan =
                String(item.variantId) === String(itemVariant) &&
                String(item.sellingPlanId) === String(sellingPlanId);

            return sameKey || sameVariantPlan;
        }) || null;
    }

    async function handleSingleConversion(button) {
        if (!button || button.dataset.loading === 'true') return;

        const itemKey = button.getAttribute('data-item-key');
        const itemVariant = button.getAttribute('data-item-variant');
        const sellingPlanId = button.getAttribute('data-selling-plan-id');
        const quantity = button.getAttribute('data-quantity') || 1;

        if (!itemVariant || !sellingPlanId) {
            console.error('Missing variant ID or selling plan ID for subscription conversion.', {
                itemKey,
                itemVariant,
                sellingPlanId,
                quantity
            });
            return;
        }

        setButtonLoading(button, 'Converting...');

        try {
            await delay(50);
            await waitForShippingProtectionIfRunning();

            const cachedItem = getCachedConversionItem(itemKey, itemVariant, sellingPlanId);
            let removeId = itemKey || cachedItem?.key || '';

            if (!removeId) {
                const cart = await getFreshCart();

                const matchingItem = cart.items.find(item =>
                    Number(item.variant_id) === Number(itemVariant) &&
                    item.selling_plan_allocation == null
                );

                if (matchingItem && matchingItem.key) {
                    removeId = matchingItem.key;
                }
            }

            if (!removeId) {
                throw new Error('Could not find one-time cart line to remove.');
            }

            const changeResponse = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    id: removeId,
                    quantity: 0
                }),
                cache: 'no-store'
            });

            if (!changeResponse.ok) {
                const text = await changeResponse.text();
                throw new Error(text || 'Normal product remove failed');
            }

            const addResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    id: itemVariant,
                    quantity: quantity,
                    selling_plan: sellingPlanId
                }),
                cache: 'no-store'
            });

            if (!addResponse.ok) {
                const text = await addResponse.text();
                throw new Error(text || 'Subscription product add failed');
            }

            let checkout_url = '/checkout';

            if (quantity == 3 || quantity == 2 || quantity == 1) {
                checkout_url = '/checkout?discount=30%25%20OFF%21';
            }

            button.textContent = 'Converted';

            const currentItem = button.closest('.conversion-item');
            if (currentItem) {
                currentItem.remove();
            }

            cachedConversionItems = cachedConversionItems.filter(item => {
                if (itemKey && item.key === itemKey) return false;

                return !(
                    String(item.variantId) === String(itemVariant) &&
                    String(item.sellingPlanId) === String(sellingPlanId)
                );
            });

            const remainingItems = productList
                ? productList.querySelectorAll('.conversion-item').length
                : document.querySelectorAll('.conversion-item').length;

            if (remainingItems > 0) {
                const noThanksBtn = document.getElementById('no-thanks-button');
                const redirectCheckout = document.getElementById('re-direct-checkout');

                if (noThanksBtn) {
                    noThanksBtn.setAttribute('href', checkout_url);
                }

                if (redirectCheckout) {
                    redirectCheckout.style.display = 'block';
                }
            } else {
                const redirectCheckout = document.getElementById('re-direct-checkout');

                if (redirectCheckout) {
                    redirectCheckout.style.display = 'none';
                }

                window.location.href = checkout_url;
            }
        } catch (error) {
            console.error("Error converting item:", error);
            resetButtonLoading(button, 'Claim Offer');
        }
    }

    async function syncShippingProtectionIfNeeded(existingCart = null) {
        const productEl = document.querySelector('.shipping-protection-product');
        if (!productEl) return;

        const preSelected = productEl.getAttribute('data-selected');
        if (preSelected !== "true") return;

        const item_variant_id = Number(productEl.dataset.id);
        const item_selling_plan_id = Number(productEl.dataset.sellingplanId);

        if (!item_variant_id || !item_selling_plan_id) return;

        const cart = existingCart || await getFreshCart();

        if (!cart.items || cart.items.length === 0) return;

        const hasSubscription = cart.items.some(item =>
            item.selling_plan_allocation != null &&
            Number(item.variant_id) !== Number(item_variant_id)
        );

        cachedHasSubscriptionForUpsell = hasSubscription;
        window.__upsellCartHasSubscription = hasSubscription;

        const existingProtectionItems = cart.items.filter(item =>
            Number(item.variant_id) === Number(item_variant_id)
        );

        if (existingProtectionItems.length > 0) {
            const updates = {};

            existingProtectionItems.forEach(item => {
                if (item.key) {
                    updates[item.key] = 0;
                }
            });

            if (Object.keys(updates).length > 0) {
                const updateResponse = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates }),
                    cache: 'no-store'
                });

                if (!updateResponse.ok) {
                    const text = await updateResponse.text();
                    throw new Error(text || 'Shipping protection remove failed');
                }
            }
        }

        const payload = {
            items: [{
                id: item_variant_id,
                quantity: 1,
                ...(hasSubscription ? { selling_plan: item_selling_plan_id } : {})
            }]
        };

        const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload),
            cache: 'no-store'
        });

        if (!addResponse.ok) {
            const text = await addResponse.text();
            throw new Error(text || 'Shipping protection add failed');
        }
    }

    async function handleCheckoutLogic() {
        if (isCheckoutProcessing) return;

        isCheckoutProcessing = true;

        try {
            await waitForMobileDrawerSettle();

            let cartState = getCartStateFromDOM();
            let cartForShippingProtection = null;

            if (isMobileViewport() && cartState.itemCount === 0) {
                try {
                    cartForShippingProtection = await getFreshCart();
                    cartState = {
                        ...getCartStateFromCart(cartForShippingProtection),
                        itemCount: cartForShippingProtection.items ? cartForShippingProtection.items.length : 0
                    };
                } catch (error) {
                    console.error('Mobile cart fallback failed:', error);
                }
            }

            const hasSubscription = cartState.hasSubscription;
            const hasOneTime = cartState.hasOneTime;

            cachedHasSubscriptionForUpsell = hasSubscription;
            window.__upsellCartHasSubscription = hasSubscription;

            cachedConversionItems = collectOneTimeItems();

            shippingProtectionPromise = syncShippingProtectionIfNeeded(cartForShippingProtection)
                .catch(err => {
                    console.error('Shipping protection error:', err);
                });

            if (hasOneTime && !hasSubscription) {
                triggerUpsellPopup();
            } else if (hasSubscription) {
                triggerUpsellPopup();
            } else {
                await proceedToCheckout('/checkout');
            }
        } catch (error) {
            console.error('Checkout logic failed:', error);
            await proceedToCheckout('/checkout');
        } finally {
            setTimeout(() => {
                isCheckoutProcessing = false;
            }, 500);
        }
    }

    function triggerSubscriptionPopup() {
        let oneTimeItems = collectOneTimeItems();

        if (oneTimeItems.length === 0 && cachedConversionItems.length > 0) {
            oneTimeItems = cachedConversionItems;
        }

        if (oneTimeItems.length > 0) {
            buildProductList(oneTimeItems);

            if (popup) {
                popup.style.display = 'flex';
            } else {
                proceedToCheckout();
                return;
            }

            const cartDrawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');

            if (cartDrawer && typeof cartDrawer.close === 'function') {
                cartDrawer.close();
            }
        } else {
            proceedToCheckout();
        }
    }

    function triggerUpsellPopup() {
        const upsell_popup = document.getElementById('upsell-popup');

        if (upsell_popup) {
            upsell_popup.style.display = 'flex';
        } else {
            proceedToCheckout();
        }
    }

    async function handleUpsellAdd(button, options = {}) {
        if (!button || button.dataset.loading === 'true') return;

        const allowCheckoutWithoutProduct = options.allowCheckoutWithoutProduct === true;
        const loadingText = options.loadingText || 'Adding...';

        setButtonLoading(button, loadingText);

        const itemVariant2 = button.getAttribute('data-product-id');
        const itemSellingPlan2 = button.getAttribute('data-selling-id') || '';

        try {
            await delay(50);
            await waitForShippingProtectionIfRunning();

            /**
             * For dont-want button:
             * If no product id assigned, direct checkout.
             * If product id assigned, add that product then checkout.
             */
            if (!itemVariant2) {
                if (allowCheckoutWithoutProduct) {
                    await proceedToCheckout('/checkout');
                    return;
                }

                throw new Error('Upsell product variant ID missing.');
            }

            let hasSubscription2 = false;

            if (typeof cachedHasSubscriptionForUpsell === 'boolean') {
                hasSubscription2 = cachedHasSubscriptionForUpsell;
            } else if (typeof window.__upsellCartHasSubscription === 'boolean') {
                hasSubscription2 = window.__upsellCartHasSubscription;
            } else {
                const cartRes2 = await fetch('/cart.js', { cache: 'no-store' });
                const cart2 = await cartRes2.json();

                hasSubscription2 = cart2.items.some(item =>
                    item.selling_plan_allocation != null
                );
            }

            let additionsPayload2;

            if (hasSubscription2 && itemSellingPlan2) {
                additionsPayload2 = {
                    items: [{
                        id: itemVariant2,
                        quantity: 1,
                        selling_plan: itemSellingPlan2
                    }]
                };
            } else {
                additionsPayload2 = {
                    items: [{
                        id: itemVariant2,
                        quantity: 1
                    }]
                };
            }

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(additionsPayload2),
                cache: 'no-store'
            });

            if (!response.ok) {
                const text = await response.text();
                throw new Error(text || '400 Bad Request');
            }

            window.location.href = '/checkout';
        } catch (error) {
            console.error("Error adding item:", error);
            resetButtonLoading(button, button.dataset.originalText || 'Add');
        }
    }

    const lastActionMap = new WeakMap();

    function shouldSkipDuplicate(el, actionName) {
        if (!el) return false;

        const now = Date.now();
        const last = lastActionMap.get(el);

        if (
            last &&
            last.actionName === actionName &&
            now - last.time < 700
        ) {
            return true;
        }

        lastActionMap.set(el, {
            actionName,
            time: now
        });

        return false;
    }

    async function handleGlobalAction(event) {
        const target = event.target;

        if (!target || typeof target.closest !== 'function') return;

        const convertButton = target.closest('.convert-single-item-btn');
        if (convertButton) {
            event.preventDefault();
            event.stopPropagation();

            if (shouldSkipDuplicate(convertButton, 'convert')) return;

            await handleSingleConversion(convertButton);
            return;
        }

        const wantButton = target.closest('.upsell-atc-want-btn');
        if (wantButton) {
            event.preventDefault();
            event.stopPropagation();

            if (shouldSkipDuplicate(wantButton, 'upsell-want')) return;

            await handleUpsellAdd(wantButton, {
                allowCheckoutWithoutProduct: false,
                loadingText: 'Adding...'
            });
            return;
        }

        const dontWantButton = target.closest('.upsell-atc-dont-want-btn');
        if (dontWantButton) {
            event.preventDefault();
            event.stopPropagation();

            if (shouldSkipDuplicate(dontWantButton, 'upsell-dont-want')) return;

            /**
             * If this button has data-product-id, it will add that assigned product.
             * If not, it will go checkout directly.
             */
            await handleUpsellAdd(dontWantButton, {
                allowCheckoutWithoutProduct: true,
                loadingText: 'Processing...'
            });
            return;
        }

        const closeIcon = target.closest('.upsell-close-icon');
        if (closeIcon) {
            event.preventDefault();
            event.stopPropagation();

            if (shouldSkipDuplicate(closeIcon, 'close')) return;

            await proceedToCheckout('/checkout');
            return;
        }

        const noThanksBtn = target.closest('#no-thanks-button');
        if (noThanksBtn) {
            event.preventDefault();
            event.stopPropagation();

            if (shouldSkipDuplicate(noThanksBtn, 'no-thanks')) return;

            const href = noThanksBtn.getAttribute('href') || '/checkout';
            await proceedToCheckout(href);
            return;
        }

        const checkoutButton = target.closest(CHECKOUT_BTN_SELECTOR);
        if (checkoutButton) {
            event.preventDefault();
            event.stopPropagation();

            if (shouldSkipDuplicate(checkoutButton, 'checkout')) return;

            await handleCheckoutLogic();
        }
    }

    document.addEventListener('touchend', handleGlobalAction, {
        capture: true,
        passive: false
    });

    document.addEventListener('click', handleGlobalAction, true);
});